import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import '../styles/mudatagridcustomstyle.css';
import axios from 'axios';
import MaterialNotifyComponent from './MaterialNotifyComponent';
import { getAuthenticationToken } from '../utils/TokenHandler';
import { Backdrop, CircularProgress, Button } from '@mui/material';
import MainPageCompenent from './MainPageCompenent';
import { styled as muiStyled } from '@mui/material/styles';

const columns = [
    {
        field: 'id',
        headerName: '#',
        editable: false,
        flex: 1
    },
    {
        field: 'ticketDate',
        headerName: 'تاریخ ارسال پیام',
        editable: false,
        flex: 2,
    },
    {
        field: 'ticketTitle',
        headerName: 'عنوان پیام',
        editable: false,
        flex: 3,
    },
    {
        field: 'ticketBody',
        headerName: 'متن پیام',
        editable: false,
        flex: 8,
    },
];
const footerButtonStyle = {
    display: 'inline-block',
    padding: '0px 20px',
    width: '100%'
};
const formButtonElementStyle = {
    margin: "10px 0",
    backgroundColor: '#014171',
    fontSize: 'x-large',
    boxShadow: '0px 10px 20px 5px rgba(255, 255, 255, 0.2)'
};
const footerButtonContainerStyle = {
    display: 'flex',
    justifyContent: 'space-evenly',
    position: 'fixed', left: '0',
    bottom: '0', width: '100%',
    zIndex: '1'
};
const StyledDataGrid = muiStyled(DataGrid)(({ theme }) => ({
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#0072bc', // رنگ پس‌زمینه هدر
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        color: '#ffffff', // رنگ متن هدر
    },
    '& .MuiDataGrid-row:nth-of-type(odd)': {
        backgroundColor: '#0072bc', // رنگ پس‌زمینه برای سطرهای فرد
        color: '#ffffff'
    },
    '& .MuiDataGrid-row:nth-of-type(even)': {
        backgroundColor: '#ffffff', // رنگ پس‌زمینه برای سطرهای زوج
    },
    '& .MuiDataGrid-footerContainer': {
        backgroundColor: '#0072bc', // رنگ پس‌زمینه فوتر
        color: '#ffffff'
    },
    '& .MuiTablePagination-displayedRows': {
        color: '#ffffff'
    },
    '& .MuiSvgIcon-root': {
        color: '#ffffff'
    }
}));

function ScoreList(props) {
    const [customerSupportSystemTicketing, setCustomerSupportSystemTicketing] = useState([]);
    const [messageNotify, setMessageNotify] = useState({ severity: "error", message: "", open: false });
    const [open, setOpen] = useState(false);
    useEffect(() => {
        const url = 'api/v1/SupportSystemTicketing/GetCustomerSupportSystemTicketing';
        const urlParams = {
            params:
            {
                CustomerId: getAuthenticationToken().userID,
                SupportSystemTicketingType: 1
            }
        };
        setOpen(true);
        axios.get(url, urlParams).then((response) => {
            setCustomerSupportSystemTicketing(response.data);
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در فراخوانی اطلاعات از سرور",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }, []);

    return (customerSupportSystemTicketing !== null) && (

        <MainPageCompenent>
            <StyledDataGrid className={'rtl-grid'}
                style={{ margin: '20px auto' }}
                rows={customerSupportSystemTicketing}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                direction="row-reverse"
                disableSelectionOnClick
                disableColumnMenu
                exportDataAsCsv={(e) => console.log('exportDataAsCsv', e)}
            />
            <div style={footerButtonContainerStyle}>
                <div style={footerButtonStyle}>
                    <Button
                        onClick={() => { props.history.push('/') }}
                        id="cancel"
                        name="cancel"
                        variant="contained"
                        color="success"
                        fullWidth
                        style={formButtonElementStyle}>انصراف</Button>
                </div>
            </div>
            <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </MainPageCompenent>
    );
}

export default ScoreList;